import React from "react";
import PropTypes from "prop-types";

/**
 * An SVG icon. Stroke and fill can be supplied as props OR applied via CSS
 * using the className prop.
 *
 * @param {string} className  A classname to be applied to the element
 * @param {string} stroke     A colour
 * @param {string} fill       A colour
 */
const FilterIcon = ({ className, stroke, fill }) => {
  return (
    <span className={className}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="22"
        height="18"
        viewBox="0 0 22 16"
      >
        <g fill="none" fillRule="evenodd">
          <path stroke={stroke} d="M0 2.034h22" />
          <ellipse cx="4.132" cy="2.034" fill={fill} rx="2.037" ry="2.034" />
          <g transform="translate(0 5.696)">
            <path stroke={stroke} d="M0 2.034h22" />
            <ellipse cx="16.818" cy="2.034" fill={fill} rx="2.037" ry="2.034" />
          </g>
          <g transform="translate(0 11.392)">
            <path stroke={stroke} d="M0 2.034h22" />
            <ellipse cx="10.287" cy="2.034" fill={fill} rx="2.037" ry="2.034" />
          </g>
        </g>
      </svg>
    </span>
  );
};

FilterIcon.propTypes = {
  className: PropTypes.string,
  fill: PropTypes.string,
  stroke: PropTypes.string
};

export default FilterIcon;



// WEBPACK FOOTER //
// ./src/components/FilterIcon/index.js